<template>
  <div>
    <transition-group
      name="s-zoom-in-center"
      tag="div">
      <template v-for="(emailItem, emailItemIndex) in emails">
        <div
          :key="emailItemIndex"
          class="flex">
          <sInput
            clearable
            :max-length="400"
            :value="emails[emailItemIndex].trim()"
            @update:value="value => updateValue(emailItemIndex, value)"/>
          <sButton
            class="my-auto ml-2"
            icon="delete"
            small
            type="text"
            @click="deleteEmail(emailItemIndex)"/>
        </div>
      </template>
    </transition-group>
    <sButton
      v-if="multi"
      class="mt-2"
      small
      type="border"
      @click="addNewEmail">
      {{ $t('Common.Add') }}
    </sButton>
  </div>
</template>
<script>
export default {
  name: 'settingsList',
  methods: {
    deleteEmail(index) {
      const result = this.$_.cloneDeep(this.emails)
      result.splice(index, 1)
      this.emails = result
    },
    addNewEmail() {
      const result = this.$_.cloneDeep(this.emails)
      result.push('')
      this.emails = result
    },
    updateValue(index, value) {
      const result = this.$_.cloneDeep(this.emails)
      result[index] = value
      this.emails = result
    }
  },
  computed: {
    emails: {
      get() {
        if (!this.value) {
          return ['']
        }
        return this.value
      },
      set(newValue) {
        this.$emit('update:value', newValue)
      }
    }
  },
  props: {
    multi: {
      type: Boolean,
      default: true
    },
    value: {
      type: Array
    }
  },
}
</script>
